export const PlanTypes = {
    foundation: 'foundation',
    pro: 'pro',
} as const;

export type PlanType = typeof PlanTypes[keyof typeof PlanTypes];

export const PlanKinds = {
    acoustic: 'acoustic',
    electronic: 'electronic',
} as const;

export type PlanKind = typeof PlanKinds[keyof typeof PlanKinds];

export const BillingCycles = {
    monthly: 'monthly',
    yearly: 'yearly',
} as const;

export type BillingCycle = typeof BillingCycles[keyof typeof BillingCycles];

export type ResolvedAffiliate = {
    param: string;
    affiliateId: string;
    isCustom: boolean;
};

export type CustomerCreditBalance = {
    currencyCode: string;
    availableBalance: number;
};

export type Amount = {
    amount: string;
    currency: string;
};
